import { setAlert } from "../alert";
import {
    SET_PROPERTY_FIELDS,
    SET_PROPERTY_TITLE_NOTES,
    REMOVE_PROPERTY_TITLE_NOTES
} from "../../types";
import { handleError } from "../error";

/**
 * @name    updateTitle
 * @param   event
 * @returns {function(...[*]=)}
 */
export const updateTitle = event => async(dispatch, getState) => {
    try {
    //  DESC:TITLE - TITLE CLEARED
        const { name, value } = event.target;
        const { properties: { propertyFields } } = getState();

        //  DESC:Pre-defined an empty Error
        const errors = [];

        //  DESC:Take out the  old title_invoice_date from propertyFields
        //  DESC:give it a old_title_invoice_date name because
        //  DESC:It will conflict with the new_title_invoice_date
        //  DESC:to later on compare or setting value below
        const { title_invoice_date: old_title_invoice_date } = propertyFields;

        //  DESC: Destructuring from PropertyFields and update new values to newPropertyFields
        const newPropertyFields = {
            ...propertyFields,
            [event.target.name]: event.target.value
        };

        //  DESC:Get newly updated fields from newPropertyFields
        const {
            title_status,
            title_referred_to_legal,
            title_cleared_date,
            title_referred_to_legal_date,
            title_billed,
            title_invoice_date: new_title_invoice_date,
            title_invoice_number
        } = newPropertyFields;

        //  DESC:Pre-defined title statuses and legal statuses
        const NOT_CLEARED = 168;
        // const CLEARED = 169;
        // const Yes = "Y";
        const No = "N";
        const Unbillable = "U";

        //  DESC:Checking for NOT_CLEARED title status
        //  DESC:Remove title cleared date from property fields and set it to emplty
        if (
            (!title_status || parseInt(title_status) === NOT_CLEARED) &&
            title_cleared_date
        ) {
            newPropertyFields.title_cleared_date = "";
            errors.push(
                "Title status is Not Clear. Title Cleared Date is removed"
            );
        }

        //  DESC:Checking for Referred to Legal with No value
        //  DESC:Remove Referral Date and set it to empty
        if (title_referred_to_legal === No && title_referred_to_legal_date) {
            newPropertyFields.title_referred_to_legal_date = "";
            errors.push(
                "Title is NOT Referred to Legal. Referral Date is removed"
            );
        }

        //  DESC:Checking for Title Billed with No value
        //  DESC:Remoove Invoice Date and Invoice Number if they exist
        if (
            title_billed === No &&
            (new_title_invoice_date || title_invoice_number)
        ) {
            if (new_title_invoice_date) {
                newPropertyFields.title_invoice_date = "";
                errors.push("Title is NOT Billed. Invoice Date is removed");
            }
            if (title_invoice_number) {
                newPropertyFields.title_invoice_number = "";
                errors.push("Title is NOT Billed. Invoice Number is removed");
            }
        }
        else if (title_billed === Unbillable) {
            if (title_invoice_number) {
                newPropertyFields.title_invoice_number = "";
                errors.push("Title is  Unbilled. Invoice Number is removed");
            }
            if (new_title_invoice_date !== old_title_invoice_date) {
                newPropertyFields.title_invoice_date = old_title_invoice_date;
                errors.push(
                    "Title is  Unbilled. Invoice Date can't be changed"
                );
            }
        }
        switch (name) {
            case "title_referred_to_legal": {
                const referalDate = document.querySelector(
                    '[name="title_referred_to_legal_date"]'
                );
                if (value === "Y") {
                    referalDate.disabled = false;
                }
                else if (value === "N") {
                    referalDate.disabled = true;
                }
                break;
            }
            default:
                break;
        }

        //  DESC:proceed to update value normally
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });

        //  DESC:Throw error if there is any
        if (errors.length > 0) {
            dispatch(setAlert(errors.toString(), "warning"));
        }

        if (name === "title_notes") {
            return dispatch(setTitleNotes());
        }
        return true;
    }
    catch (error) {
        dispatch(handleError(error));
        return false;
    }
};

/**
 * @name    setTitleNotes
 */
export const setTitleNotes = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields: { title_notes } } } = getState();
        let Info = [];

        if (title_notes) {
            Info = JSON.parse(title_notes);
        }
        dispatch({
            type: SET_PROPERTY_TITLE_NOTES,
            payload: Info
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name    removeTitleNotes
 */
export const removeTitleNotes = () => async dispatch => {
    try {
        dispatch({ type: REMOVE_PROPERTY_TITLE_NOTES });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};